var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M238.933 0C106.974 0 0 106.974 0 238.933s106.974 238.933 238.933 238.933 238.933-106.974 238.933-238.933C477.726 107.033 370.834.141 238.933 0zm0 443.733c-113.108 0-204.8-91.692-204.8-204.8s91.692-204.8 204.8-204.8 204.8 91.692 204.8 204.8c-.122 113.058-91.742 204.678-204.8 204.8z","key":0}),React.createElement("path",{"d":"M238.933 85.333c-9.426 0-17.067 7.641-17.067 17.067v119.467H102.4c-9.426 0-17.067 7.641-17.067 17.067S92.974 256 102.4 256h136.533c9.426 0 17.067-7.641 17.067-17.067V102.4c0-9.426-7.641-17.067-17.067-17.067z","key":1})]);
}

Time.defaultProps = {"viewBox":"0 0 477.867 477.867"};

module.exports = Time;

Time.default = Time;
